/* @ngInject */
export default function routes($stateProvider) {
  $stateProvider
    .state('authorise', {
      url: '/authorise?client_id&response_type&redirect_uri&state&member_type&membership_amount&continue',
      template: '<authorise></authorise>',
      params: { state: '/' },
      data: { pageTitle: 'Authentication in progress' },
    });
}



// WEBPACK FOOTER //
// ./client/app/authorise/authorise.routes.js